<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row justify="end">
      <v-col cols="12" sm="auto">
        <v-btn
          color="success"
          min-width="180"
          width="100%"
          x-large
          button
          @click="onCreate"
        >
          <v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
          Lưu lại
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="px-8 py-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row justify="space-between" class="mb-4">
              <v-col cols="12" sm="3">
                <h2 class="text-xl font-medium">Tạo bảo hành mới</h2>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productName"
                  outlined
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-numeric"
                  color="#FBB040"
                  label="Tên sản phẩm*"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productIMEI"
                  outlined
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-code-array"
                  color="#FBB040"
                  label="IMEI*"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="6">
                <v-select
                  v-model="productStatus"
                  prepend-inner-icon="mdi-state-machine"
                  color="#FBB040"
                  :items="productStatusList"
                  outlined
                  :rules="[rules.required]"
                  no-data-text="Không có dữ liệu"
                  label="Tình trạng sản phẩm*"
                  item-text="name"
                  loading="true"
                  item-value="id"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="6">
                <money-input
                  v-model="productPrice"
                  v-bind:label="label"
                  v-bind:placeholder="placeholder"
                  v-bind:readonly="readonly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                  v-bind:options="options"
                  v-bind:properties="properties"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="6">
                <DatePicker
                  :rules="[rules.required]"
                  v-model="productDateBuy"
                  label="Ngày mua*"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="6">
                <v-select
                  v-model="productBuyWay"
                  prepend-inner-icon="mdi-sign-yield"
                  color="#FBB040"
                  :items="productBuyWayList"
                  outlined
                  :rules="[rules.required]"
                  no-data-text="Không có dữ liệu"
                  label="Hình thức mua*"
                  item-text="name"
                  loading="true"
                  item-value="id"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productGuarran"
                  outlined
                  prepend-inner-icon="mdi-account-child"
                  color="#FBB040"
                  label="Bảo hành*"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productGuarranDate"
                  outlined
                  disabled
                  prepend-inner-icon="mdi-archive-clock-outline"
                  color="#FBB040"
                  label="Ngày hết hạn*"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productCustomerName"
                  outlined
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-account-arrow-up"
                  color="#FBB040"
                  label="Tên khách hàng*"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productCustomerPhone"
                  outlined
                  prepend-inner-icon="mdi-phone"
                  color="#FBB040"
                  label="Số điện thoại"
                  :hide-details="isMobile"
                  :maxLength="20"
                  @keypress="filter(evt)"
                /> </v-col
            ></v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productIcloud"
                  outlined
                  prepend-inner-icon="mdi-apple-icloud"
                  color="#FBB040"
                  label="Tài khoản icloud"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="6">
                <v-text-field
                  v-model="productIcloudPassword"
                  outlined
                  prepend-inner-icon="mdi-form-textbox-password"
                  color="#FBB040"
                  label="Mật khẩu"
                  :hide-details="isMobile"
                /> </v-col
            ></v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="12">
                <v-text-field
                  v-model="productNote"
                  outlined
                  prepend-inner-icon="mdi-apple-icloud"
                  color="#FBB040"
                  label="Lưu ý"
                  :hide-details="isMobile"
                /> </v-col
            ></v-row>
            <template> </template>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { required } from "~/utils/validation";
import { mapState } from "vuex";
import CardMedicine from "~/components/atoms/CardMedicine";
import VueUploadMultipleImage from "~/components/molecules/VueUploadMultipleImage.vue";
import DatePicker from "~/components/atoms/DatePicker.vue";
import MoneyInput from "~/components/atoms/MoneyInput.vue";

export default {
  name: "CreatePhoneBuy",
  components: { CardMedicine, DatePicker, VueUploadMultipleImage, MoneyInput },
  data() {
    return {
      scope: "productbuy",
      productCustomerName: null,
      productPrice: null,
      productBuyWay: 1,
      productCustomerName: null,
      productCustomerPhone: null,
      productName: null,
      productIcloud: null,
      productIMEI: null,
      productIcloudPassword: null,
      productStatus: 1,
      productNote: null,
      label: "Giá sản phẩm*",
      placeholder: " ",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: true,
      valueWhenIsEmpty: "",
      options: {
        locale: "it-IT",
        prefix: "",
        suffix: "vnđ",
        length: 30,
        precision: 0,
      },
      properties: {
        hint: "Chú ý đơn vị tính",
        prependInnerIcon: "mdi-currency-usd",
        color: "#FBB040",
      },
      productGuarran: null,
      productBuyWayList: [
        {
          id: 1,
          name: "Trả góp",
        },
        {
          id: 2,
          name: "Trả thẳng",
        },
      ],
      productStatusList: [
        {
          id: 1,
          name: "Hàng 100%",
        },
        {
          id: 2,
          name: "Hàng 99%",
        },
        {
          id: 3,
          name: "Hàng 98%",
        },
        {
          id: 4,
          name: "Hàng 97%",
        },
        {
          id: 5,
          name: "Hàng 96%",
        },
        {
          id: 6,
          name: "Hàng 95%",
        },
      ],
      valid: true,
      rules: {
        required,
      },
      panel: [0],
      errorMessage: EMPTY,
      messageError: EMPTY,
      isLoading: false,
      isLoadingActions: false,
      isPublic: false,
      productDateBuy: new Date().toLocaleDateString("vi-VN").replaceAll("/", "-"),
    };
  },
  async created() {},
  computed: {
    ...mapState({
      totalImage: (state) => state.elevator.totalImage,
      images: (state) => state.elevator.images,
    }),
    isMobile() {
      return window.innerWidth <= 640;
    },
  },
  methods: {
    removeTag(id) {
      const array = [...this.prescriptionTag];
      const index = array.findIndex((element) => element === id);
      if (index >= 0) array.splice(index, 1);
      this.prescriptionTag = array;
    },
    removeGroup(id) {
      console.log("asdasd");
      const array = [...this.prescriptionGroup];
      const index = array.findIndex((element) => element === id);
      if (index >= 0) array.splice(index, 1);
      this.prescriptionGroup = array;
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onLimitExceeded() {
      this.messageError = `Gói này CHỈ CHO PHÉP SỐ HÌNH TỐI ĐA là ${this.totalImage}`;
    },
    async onCreate() {
      await this.$refs.form.validate();
      this.errorMessage = EMPTY;
      try {
        if (this.valid) {
          this.isLoadingActions = true;
          const publicIdList = this.images.map((element) => element.publicId);
          await this.$services.phonebuyService.createPhoneBuy({
            productName: this.productName,
            productIMEI: this.productIMEI,
            productDateBuy: this.productDateBuy,
            productStatus: this.productStatus,
            productPrice: this.productPrice,
            productGuarran: this.productGuarran,
            paymentMethod: this.productBuyWay,
            customerName: this.productCustomerName,
            customerPhone: this.productCustomerPhone,
            customerIcloud: this.productIcloud,
            customerIcloudPassword: this.productIcloudPassword,
            note: this.productNote,
          });
          this.isLoadingActions = false;
          this.$router.push({ name: "PhoneBuyList" });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
      }
    },
  },
  beforeDestroy() {
    this.$store.commit("elevator/setImageList", []);
  },
};
</script>

<style scoped lang="scss">
.item {
  background-color: #c6c4c1;
  border-radius: 5px;
  .item-count {
    background-color: #474747;
    color: white;
    height: 100%;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: grey;
  opacity: 0.8;
  border: 2px solid transparent;
  border-radius: 5px;
  background-clip: padding-box;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
